import { useEffect, useMemo, useState } from "react";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";

import { SignInForm } from "./components/signin-form/signin-form";
import { ChooseMethod, OtpVerify } from "./components";
import { FacialDataState, LoginPhoneNumberState, SignInActiveStep } from "states";
import { Face, apiCall, useLocation, useNetwork } from "hooks";

import "./signin.scss";
import { FaceAuth } from "views/face-auth/face-auth";

export const SignIn = ({
  mobileNumber,
  countryCode,
  onFailed,
  onSuccess,
  onBack,
  isFaceOnly,
  is_redirect_auth,
  isRecipient,
}: any) => {
  const [signInActiveStep, setSignInActiveStep] =
    useRecoilState(SignInActiveStep);
  const [ipAddress, setIpAddress] = useState("");
  const setFacialData = useSetRecoilState(FacialDataState);

  const { locationInfo, fetchLocation } = useLocation();
  const { post } = useNetwork();

  useEffect(() => {
    fetch("https://api.ipify.org?format=json")
      .then((response) => response.json())
      .then((data) => setIpAddress(data.ip));
  }, []);

  useEffect(() => {
    if (!Object.keys(locationInfo ?? {}).length) {
      fetchLocation();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locationInfo]);

  const setLoginPhoneNumber = useSetRecoilState(LoginPhoneNumberState);

  const props = {
    onFailed,
    onSuccess,
    onBack,
    is_redirect_auth,
    isRecipient,
  };

  const getComponent = useMemo(() => {
    switch (signInActiveStep) {
      case "phone":
        return <SignInForm />;
      case "chooseMethod":
        return (
          <ChooseMethod
            {...props}
            locationInfo={locationInfo}
            ipAddress={ipAddress}
            isRecipient={isRecipient}
          />
        );
      case "otpVerify":
        return (
          <OtpVerify
            {...props}
            locationInfo={locationInfo}
            ipAddress={ipAddress}
          />
        );
      // case "face-recognize":
      //   return <FaceAuth {...props} />;
      default:
        return <SignInForm />;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [signInActiveStep, locationInfo, ipAddress]);

  useEffect(() => {
    const phone = Number(mobileNumber);

    if (phone) {
      setLoginPhoneNumber({
        phone: mobileNumber,
        countryCode: countryCode ?? "+1",
      });
      post("/biometrics/get", {
        phone: mobileNumber,
        countryCode: countryCode ?? "+1"
      }).then((data) => {
        const { descriptors, name } = data ?? {};
        if (descriptors && name) {
          setFacialData(data);
          Face.setupFacialRecoganization({
            facialData: data,
            label: name,
            descriptors,
            isApiCall: false
          });
          Face?.facialInit().then(() => {
            console.log("Face loaded");
          })
        } else {
          setFacialData({});
          Face.setupFacialRecoganization({
            facialData: {},
            label: "",
            descriptors: [],
            isApiCall: false
          });
        }
      }).catch(err => {
        console.log("Error", err)
        setFacialData({});
        Face.setupFacialRecoganization({
          facialData: {},
          label: "",
          descriptors: [],
          isApiCall: false
        });
      });
      Face.apiCalling = true;
      setSignInActiveStep("chooseMethod");
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countryCode, mobileNumber, setLoginPhoneNumber, setSignInActiveStep]);

  if (isFaceOnly && signInActiveStep !== "phone") {
    return (
      <ChooseMethod
        {...props}
        locationInfo={locationInfo}
        ipAddress={ipAddress}
        isFaceOnly={isFaceOnly}
      />
    );
  }

  return <div>{getComponent}</div>;
};
